/** Member UI / focus-message content locales (stored on user_settings.locale and focus_messages.locale). */
export const MEMBER_UI_LOCALES = ["en", "es", "fr", "de", "zh"] as const;

export type MemberUiLocale = (typeof MEMBER_UI_LOCALES)[number];

export const DEFAULT_MEMBER_UI_LOCALE: MemberUiLocale = "en";

export function isMemberUiLocale(value: string): value is MemberUiLocale {
  return (MEMBER_UI_LOCALES as readonly string[]).includes(value);
}

/**
 * Normalizes a requested locale to a valid member UI code, defaulting to English.
 */
export function normalizeMemberUiLocale(
  requested: string | undefined | null
): MemberUiLocale {
  if (requested && isMemberUiLocale(requested)) {
    return requested;
  }
  return DEFAULT_MEMBER_UI_LOCALE;
}
